import { useFeatureFlagsWithFallback } from "./useFeatureFlagsWithFallback";

interface UseFeatureFlags {
  documentTemplateUplift: () => boolean;
  errorResponseApiFlag: () => boolean;
  glassesNvicUpdate: () => boolean;
  isLodgeAIEnabled: () => boolean;
  isApplicationFormAlternativeLayout: () => boolean;
  isStatusPageEnabled: () => boolean;
  isAssetInsurance: () => boolean;
  isCommissionEnabled: () => boolean;
  isDemoCommercialApplicationEnabled: () => boolean;
  isFUISidebarNav: () => boolean;
  isQuotesUpliftEnabled: () => boolean;
  isAskFinEnabled: () => boolean;
}

const useFeatureFlags = (): UseFeatureFlags => {
  const { getFeatureFlag } = useFeatureFlagsWithFallback();

  const documentTemplateUplift = () => !!getFeatureFlag("fwa-340-document-template");
  const errorResponseApiFlag = () => !!getFeatureFlag("error-response-api-flag");
  const glassesNvicUpdate = () => !!getFeatureFlag("fwa-463-glasses-nvic");
  const isLodgeAIEnabled = () => !!getFeatureFlag("li-273-broker-loop");
  const isApplicationFormAlternativeLayout = () => !!getFeatureFlag("fwa-485-application-layout");
  const isStatusPageEnabled = () => !!getFeatureFlag("fwa-544-status-page");
  const isAssetInsurance = () => !!getFeatureFlag("fwa-510-asset-insurance");
  const isCommissionEnabled = () => !!getFeatureFlag("fwa-571-loan-details-commission");
  const isDemoCommercialApplicationEnabled = () => !!getFeatureFlag("fwa-606-demo-commercial-application");
  const isFUISidebarNav = () => !!getFeatureFlag("fwa-613-fui-sidebar-nav");
  const isQuotesUpliftEnabled = () => !!getFeatureFlag("li-441-quotes-uplift");
  const isAskFinEnabled = () => !!getFeatureFlag("fwa-757-fin-chat-agent");

  return {
    documentTemplateUplift,
    errorResponseApiFlag,
    glassesNvicUpdate,
    isLodgeAIEnabled,
    isApplicationFormAlternativeLayout,
    isStatusPageEnabled,
    isAssetInsurance,
    isCommissionEnabled,
    isDemoCommercialApplicationEnabled,
    isFUISidebarNav,
    isQuotesUpliftEnabled,
    isAskFinEnabled,
  };
};

export { useFeatureFlags };
